import React from 'react';
import PropTypes from 'prop-types';
import DocumentSharingContent from '../../DocumentSharing/DocumentSharingContent';

/**
 * Layout component of a chat widget
 * @param {object} main
 * @param {string} activeId
 * @param {string} activeDashboardId
 * @param {string} widgetId
 */
const DocumentSharing = props => {
  const { main, activeId, activeDashboardId, widgetId } = props;

  return (
    <DocumentSharingContent
      key={activeId}
      currentId={activeId}
      data={main}
      items={main && main['items'] && main['items']}
      attendees={main && main.attendees && main.attendees}
      activeDashboardId={activeDashboardId}
      widgetId={widgetId}
    />
  );
};

DocumentSharing.propTypes = {
  /** The main data */
  main: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  /** Current active ID */
  activeId: PropTypes.string,
  /** Dashboard ID */
  activeDashboardId: PropTypes.string,
  /** Current widgetId */
  widgetId: PropTypes.string,
};

DocumentSharing.defaultProps = {
  main: null,
  activeId: '',
  activeDashboardId: '',
  widgetId: null,
};

export default DocumentSharing;
